import React from 'react';
import styled from 'styled-components';



const EsReqStatusBtnBlock = styled.button`
    height: ${props => props.height || '30px'};
    margin-top: ${props => props.marginTop || '10px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    font-size: ${props => props.fontSize || '14px'};
    font-weight: ${props => props.fontWeight || '500'};
    border-radius: ${props => props.borderRadius || '14px'};
    color: ${props => props.color || '#111'} ;
    background-color: ${props => props.bgColor || '#fff'};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    border: 1px ${props => props.borderStyle || 'solid'} ${props => props.borderColor || '#fff'};
    width: ${props => props.width || '150px'};
    float: ${props => props.float || 'none'};
    min-width: ${props => props.minWidth || '0px'};
    line-height: ${props => props.lineHeight || 'normal'}; 
    padding: ${props => props.padding || '0 20px'}; 
    display: ${props => props.display || 'block'}
    overflow: hidden;
`;

const EsReqStatusBtn = (props) => {

    const handleBtnClick = () => {
        return props.onClick();
    }

    return (
        <EsReqStatusBtnBlock
            {...props}
            onClick={handleBtnClick}
        >
            {props.text}
        </EsReqStatusBtnBlock>
    );
};

export default EsReqStatusBtn;
